<!-- Date search box -->
<template>
  <div class="d-flex">
    <v-select v-model="yearsModel" :items="years" :value="years.value" @change="dateChange(1)"
      :label="$t('datepicker_year')" outlined color="primary-1">
    </v-select>
    <v-select v-model="monthsModel" :items="months" :disabled="yearsModel === ''" class="mx-2" @change="dateChange(2)"
      :label="$t('datepicker_month')" outlined color="primary-1">
    </v-select>
    <v-select v-model="daysModel" :items="days" :disabled="yearsModel === '' && monthsModel === ''"
      @change="dateChange(3)" :label="$t('datepicker_date')" outlined color="primary-1">
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    birthday: {
      type: String,
      default: ""
    }
  },
  data() {
    let birth = this.birthday.split("-");
    return {
      yearsModel: !birth[0] || birth[0] === 'NaN' ? '' : birth[0],
      years: [],
      monthsModel: !birth[1] || birth[1] === 'NaN' ? '' : birth[1],
      months: [],
      daysModel: !birth[2] || birth[2] === 'NaN' ? '' : birth[2],
      days: []
    };
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      var myDate = new Date();
      var year = myDate.getFullYear(); //Get the current year
      var month = myDate.getMonth() + 1; //Get the current month
      var day = myDate.getDate(); //Get the current day
      this.initSelectYear(year);
      this.initSelectMonth();
      this.initSelectDay(year, month);
    },
    initSelectYear(year) {
      this.years = [];
      for (let i = 7; i < 101; i++) {
        this.years.push(String(year - i));
      }
    },
    initSelectMonth() {
      this.months = [];
      for (let i = 1; i <= 12; i++) {
        this.months.push(String(i));
      }
    },
    initSelectDay(year, month) {
      var maxDay = this.getMaxDay(Number(year), Number(month));
      this.days = [];
      for (var i = 1; i <= maxDay; i++) {
        this.days.push(String(i));
      }
    },
    dateChange(type) {
      if (type == 1 || type == 2) {
        if (this.monthsModel == 0) {
          this.monthsModel = "1";
          this.daysModel = "1";
          this.initSelectDay(this.yearsModel, 1);
        } else {
          this.initSelectDay(this.yearsModel, this.monthsModel);
        }
      }

      this.emitDate();
    },
    emitDate() {
      let updatedDate = `${String(
        this.yearsModel
      )}-${Number(this.monthsModel).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}-${Number(this.daysModel).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}`;
      this.$emit("updateDate", updatedDate);
    },
    getMaxDay(year, month) {
      var new_year = year; //Take the current year
      var new_month = month++; //Take the first day of the next month for easy calculation (the last day is not fixed)
      if (month > 12) {
        //If the current month is greater than December, the year will go to the next year
        new_month -= 12; //month minus
        new_year++; //year increases
      }
      var new_date = new Date(new_year, new_month, 1); //Take the first day of the current month
      return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate(); //Get the date of the last day of the month
    }
  }
};
</script>
